import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { createCircularApi } from "../../../../services/DocumentService";
import { format } from "date-fns";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";

const AddCircularSheet = ({ show, onHide, id, handleAfterCreate }) => {
  const location = useLocation();
  const [dataInput, setDataInput] = useState({
    title: "",
    measurement_sheet_id: id,
    schedule: "",
    schedule_at: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataInput((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!dataInput.title) newErrors.title = "Title is required.";
    if (!dataInput.schedule) newErrors.schedule = "Schedule is required.";
    if (!dataInput.schedule_at)
      newErrors.schedule_at = "Scheduled date is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setIsSubmitLoading(true);
      const payload = {
        ...dataInput,
      };
      const response = await createCircularApi(payload);
      toast.success(response.data.message);
      handleAfterCreate(response.data.results);
      onHide();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred while submitting"
      );
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Circular</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          {/* Title */}
          <div className="form-group mb-3">
            <label className="form-label">
              Title<span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              placeholder="Enter Title"
              name="title"
              value={dataInput.title}
              onChange={handleChange}
            />
            {errors.title && <div className="text-danger">{errors.title}</div>}
          </div>

          {/* Schedule */}
          <div className="form-group mb-3">
            <label className="form-label">
              Schedule<span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              placeholder="Enter Schedule"
              name="schedule"
              value={dataInput.schedule}
              onChange={handleChange}
            />
            {errors.schedule && (
              <div className="text-danger">{errors.schedule}</div>
            )}
          </div>

          {/* Schedule Date and Time */}
          <div className="form-group mb-3">
            <label className="form-label">
              Schedule At<span className="text-danger">*</span>
            </label>
            <input
              type="datetime-local"
              className="form-control"
              name="schedule_at"
              value={dataInput.schedule_at}
              onChange={handleChange}
            />
            {errors.schedule_at && (
              <div className="text-danger">{errors.schedule_at}</div>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={isSubmitLoading}
        >
          {isSubmitLoading ? "Submitting..." : "Submit"}
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCircularSheet;
